import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class BehaviorSignalEndpointsService {
  readonly #service = inject(ServicesService);

  public getBehaviorSignals(actor: string, contentIdentifier: string): string {
    return this.#service.think(
      `behavior/signals/${contentIdentifier}?actor=${actor}`,
    );
  }
}
